import { Box, Skeleton } from '@mui/material';

import { Card } from '../Card/Card';

export const CardsListSkeleton = ({ cardCount = 3, cardRows = 1 }: { cardCount?: number; cardRows?: number }) => {
  return (
    <>
      {Array.from({ length: cardCount }).map((_, index) => (
        <Box mb={2} key={index}>
          <Card key={index} title={<Skeleton variant="text" width="200px" />}>
            {Array.from({ length: cardRows }).map((_, index) => (
              <Box mb={2} key={index}>
                <Skeleton variant="rectangular" />
              </Box>
            ))}
          </Card>
        </Box>
      ))}
    </>
  );
};
